import { createSelector } from "@reduxjs/toolkit";
import { IAppState } from "../types";

const grammarSelectors = (state: IAppState) => state.grammar;


export const getGrammars = createSelector(
    [grammarSelectors],
    (app) => app?.grammar || []
);

export const getSelectedGrammars = createSelector(
    [grammarSelectors],
    (app) => app?.selectedGrammars || []
);

export const allowUpsertGrammar = createSelector(
    [grammarSelectors],
    (app) => app?.upsertGrammar,
);

export const getglobalGrammars = createSelector(
    [grammarSelectors],
    (app) => app?.grammar || []
);

export const getglobalSelectedGrammars = createSelector(
    [grammarSelectors],
    (app) => app?.selectedGrammars || []
);

export const allowglobalUpsertGrammar = createSelector(
    [grammarSelectors],
    (app) => app?.upsertGrammar,
);

